'use client';

import { HStack } from '@chakra-ui/react';
import { useCustomLocale } from '@/shared/hooks/use-custom-locale';
import { Button } from '@/shared/ui/button';
import { Text } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { shipperTagApi } from '@/entities/branch/api';
import { IMultiLang } from '@/_types';
import { useTranslations } from 'next-intl';
import { useQueryState } from 'nuqs';

function TagsBar() {
    const t = useTranslations();
    const { data } = useQuery({
        queryKey: ['tags'],
        queryFn: () => shipperTagApi.getAll({ page: 1, limit: 30 }),
    });


    return (
        <>
            <Text fontSize='lg' fontWeight={600} mb={2} mt={2} pl={4}>{t('for_you')}</Text>
            <HStack
                px={4}
                gap={1}
                maxWidth="100%"
                flexWrap={{ base: 'nowrap', md: 'wrap' }}
                overflowX={{ base: 'auto', md: 'visible' }}
                scrollbar={'hidden'}
                align="stretch"
                mb={3}
            >
                {data?.shipper_tags?.map((item, idx) => (
                    <TagChip
                        data={item}
                        key={`${item.id}-${idx}`}
                    />
                ))}
            </HStack>
        </>
    );
}

function TagChip({
    data,
}: {
    data: { id: string; title: IMultiLang };
}) {
    const currentLocale = useCustomLocale();
    const [tagId, setTagId] = useQueryState('tag_id');

    return (
        <Button
            fontSize='13px'
            height='32px'
            rounded="full"
            size="sm"
            fontWeight={500}
            {...(tagId === data?.id
                ? {
                    bg: 'primary',
                    color: 'primary.text',
                    _hover: {
                        bg: 'primary.hover',
                    },
                }
                : {
                    variant: 'subtle',
                })}
            onClick={() => setTagId(tagId === data?.id ? null : data?.id)}
        >
            {data?.title?.[currentLocale]}
        </Button>
    );
}


export default TagsBar;
